// dismiss notification
export function dismissNotification(index) {
    return (dispatch) => {
        dispatch({
            type: 'DISMISS_NOTIFICATION',
            index,
        });
    };
}

export function showNotificationPopUp(message, description) {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_ERROR_POPUP',
            message,
            description,
            custom: true,
        });
    };
}

export function showErrorPopUp(message, error) {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_ERROR_POPUP',
            message,
            error,
        });
    };
}

export function dismissNotificationPopUp() {
    return (dispatch) => {
        dispatch({
            type: 'DISMISS_NOTIFICATION_POPUP',
        });
    };
}
